<template>
<el-checkbox
  :label="infoObj.deviceGuid"
  v-model="infoObj.checked"
  @change="checkElevator">
  <span>
    {{infoObj.elevatorNo}}
    <!-- <span v-if="idx === 0 && hasTip" :class="{'tip_txt':true, 'more': infoObj.value.length > 4}">
      请选择您需要监播的点位，监播将以服务提交时间为开始时间。
      <span :class="['tip_arrow', {'more':infoObj.value.length > 4}]"></span>
    </span> -->
  </span>
</el-checkbox>
</template>

<script>
import ListMixin from './mixin/ListMixin'

export default {
  name: 'MonitElevator',
  mixins: [ ListMixin ],
  destroyed () {
    this.infoObj = null
  },
  methods: {
    checkElevator (val) { // val: true/false 是否选中
      console.log('---\n设备:' + this.infoObj.elevatorNo + ',id:' + this.infoObj.deviceGuid + ',选中：' + val + '\n---')
      this.changeItemStatus(this.infoObj, val)
      // this.$emit('check-change', this.infoObj.deviceGuid, val)
      this.$emit('check-change')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
